import { styled } from 'styled-components';
import { FormGroup as FormGroupCus } from '../../../withdraw-form/styles';
import {
  InputWrapper,
  FormFieldWrapper,
} from '@/shared/ui/form/form-field/styles';

const InputField = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 16px;
  align-self: stretch;
  background: #27262b;
  border-radius: ${({ $roundTop, $roundBottom }) =>
    $roundTop && $roundBottom
      ? '8px'
      : $roundTop
        ? '8px 8px 0 0'
        : $roundBottom
          ? '0 0 8px 8px'
          : '0'};
`;

const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  text-align: left;
`;

const FormGroup = styled(FormGroupCus)`
  margin-top: 0;
  gap: 24px;
`;

const BoxBase = styled.div`
  display: flex;
  flex-direction: column;
  ${FormFieldWrapper} {
    width: 55px;
    word-break: break-word;
  }
`;

const BoxCvv = styled(BoxBase)`
  text-align: right;
  ${InputWrapper} {
    display: flex;
    justify-content: right;
  }
`;
const BoxExpire = styled(BoxBase)``;

export { InputField, FormItem, FormGroup, BoxCvv, BoxExpire };
